// extracted by mini-css-extract-plugin
export default {"page":"App_page__36d+b","content":"App_content__eZyx2"};